// components/Database.js
import React from 'react';

import Navbar from '../Components/Database/Navbar';
import { Outlet } from 'react-router-dom';

const Database = () => {
  // const [selectedDatabase, setSelectedDatabase] = useState('products'); // Track selected database

  // const handleDatabaseSelect = (dbType) => {
  //   setSelectedDatabase(dbType);
  // };

  return (
    <div>
      <Navbar  />
      {/* <div>
        {selectedDatabase === 'products' ? <ProductDatabase /> : <IngredientDatabase />}
      </div> */}

      <Outlet/>     
      
    
    </div>
  );
};

export default Database;
